export default __webpack_public_path__ + "static/media/ikonka galerii.5c6651b9.png";